import { Bounds } from '@ardoq/graph';
import type { BlocksViewNode } from 'tabview/blocks/types';
import {
  BLOCKS_VIEW_NODE_PAD,
  BLOCKS_VIEW_HEADER_INNER_HEIGHT,
  BLOCKS_VIEW_NODE_MARGIN,
  INVALID_RECTANGLE_SIDES,
} from '../../consts';
import { openGroupHeaderTopTextBaseline } from '../util';

const groupExpanderRect = (node: BlocksViewNode, cell = node.cell): Bounds => {
  if (!cell) {
    return INVALID_RECTANGLE_SIDES;
  }
  const sz = BLOCKS_VIEW_HEADER_INNER_HEIGHT;
  const pad = BLOCKS_VIEW_NODE_PAD;

  const left = cell[0] + BLOCKS_VIEW_NODE_MARGIN + pad;
  const centerY = openGroupHeaderTopTextBaseline(node, cell);
  const top = centerY - sz / 2;

  return [left, top, left + sz, top + sz];
};

export { groupExpanderRect };
